import Vue from 'vue'
import VueRouter from 'vue-router'
import NProgress from 'nprogress'
import '@/assets/css/nprogress.css'
import store from '@/store/demo'
import openAccountStore from '@/store/openAccount'
import JSBridge from '@fs/jsbridge/dist/lib/jsBridge.js'
import { approvingStatusCode, preOpenStatusCode } from '@/views/openAccount/step.config'
import { i18n } from '@/i18n/openAccount/index.js'
// 合规多语言（用于在 openAccount 应用中显示合规页面文案）
import complianceI18n from '@/i18n/complianceAccount/index.js'
import MYLINK_JSBRIDGE from '@fs/jsbridge/dist/lib/mylinkJsBridge.js'
import { thsI18NJsBridge } from '@fs/jsbridge'
import { setTheme, removeTheme } from '@/utils/theme'
import { getRunEnv } from '@/utils/env'
import { isTHSI18NApp } from '@/utils'
import { HKPage } from './HK'
import { detectAndSaveComplianceFlags } from '@/utils/complianceSession'

Vue.use(VueRouter)

NProgress.configure({ showSpinner: false })

export const FISL_ACCOUNT_OPEN_TITLE = 'FISL Account Open'

const router = new VueRouter({
    // mode: 'history',
    routes: [
        {
            path: '/',
            redirect: '/account',
        },
        {
            path: '/statement',
            name: 'STATEMENT',
            meta: {
                title: '复星国际证券开户',
            },
            component: () => import(/* webpackChunkName: "openAccountMain" */ '@/views/openAccount/step/Statement'),
        },
        {
            path: '/account',
            name: 'account',
            meta: {
                title: '复星国际证券开户',
            },
            component: () => import(/* webpackChunkName: "openAccountMain" */ '@/views/openAccount/pages/home.vue'),
        },
        {
            path: '/IDcard',
            name: 'IDCARD',
            meta: {
                title: '复星国际证券开户',
            },
            component: () => import(/* webpackChunkName: "openAccountMain" */ '@/views/openAccount/step/IdCard'),
        },
        {
            path: '/bankCard',
            name: 'BANKCARD',
            meta: {
                title: '复星国际证券开户',
            },
            component: () => import(/* webpackChunkName: "openAccountMain" */ '@/views/openAccount/step/BankCard'),
        },
        {
            path: '/jobStatus',
            name: 'EMPLOYMENT',
            meta: {
                title: '复星国际证券开户',
            },
            component: () => {
                // 检查是否为合规开户模式
                const isCompliance =
                    sessionStorage.getItem('complianceAuditFlag') === 'Y' || new URLSearchParams(window.location.search).get('compliance') === 'Y'

                if (isCompliance) {
                    return import(/* webpackChunkName: "complianceJobStatus" */ '@/views/complianceAccount/JobStatus.vue')
                }
                return import(/* webpackChunkName: "openAccountMain" */ '@/views/openAccount/step/Employment')
            },
        },
        {
            path: '/Finance',
            name: 'FINANCE',
            meta: {
                title: '复星国际证券开户',
                des: '财务状况',
            },
            component: () => {
                // 检查是否为合规开户模式
                const isCompliance =
                    sessionStorage.getItem('complianceAuditFlag') === 'Y' || new URLSearchParams(window.location.search).get('compliance') === 'Y'

                if (isCompliance) {
                    return import(/* webpackChunkName: "complianceFinance" */ '@/views/complianceAccount/Finance.vue')
                }
                return import(/* webpackChunkName: "openAccountMain" */ '@/views/openAccount/step/Finance')
            },
        },
        {
            path: '/Investment',
            name: 'INVESTMENT',
            meta: {
                title: '复星国际证券开户',
                des: '投资经验',
            },
            component: () => import(/* webpackChunkName: "openAccountMain" */ '@/views/openAccount/step/Investment'),
        },
        {
            path: '/selectAccount',
            name: 'ACCOUNT',
            meta: {
                title: '复星国际证券开户',
                des: '选择账户',
            },
            component: () => import(/* webpackChunkName: "openAccountMain" */ '@/views/openAccount/step/Account'),
        },
        {
            path: '/selectTradeClasses',
            name: 'TRADECLASSES',
            meta: {
                title: '复星国际证券开户',
                des: '交易品种',
            },
            component: () => import(/* webpackChunkName: "openAccountMain" */ '@/views/openAccount/step/TradeClasses'),
        },
        {
            path: '/disclosure',
            name: 'IDENTITYEXPOSURE',
            meta: {
                title: '复星国际证券开户',
                des: '身份披露',
            },
            component: () => import(/* webpackChunkName: "openAccountMain" */ '@/views/openAccount/step/IdentityExposure'),
        },
        {
            path: '/TaxInfo',
            name: 'TAXW8',
            meta: {
                title: '复星国际证券开户',
                des: '税务信息',
            },
            component: () => import(/* webpackChunkName: "openAccountMain" */ '@/views/openAccount/step/TaxW8'),
        },
        {
            path: '/informationSupplement',
            name: 'INFORMATION_SUPPLEMENT',
            meta: {
                title: '复星国际证券客服资料复核',
                des: '补充信息',
            },
            component: () => import(/* webpackChunkName: "complianceAccountViews" */ '@/views/complianceAccount/InformationSupplement.vue'),
        },
        {
            path: '/backgroundDisclosure',
            name: 'BACKGROUND_DISCLOSURE',
            meta: {
                title: '复星国际证券客服资料复核',
                des: '背景状况披露',
            },
            component: () => import(/* webpackChunkName: "complianceAccountViews" */ '@/views/complianceAccount/BackgroundDisclosure.vue'),
        },
        {
            path: '/risk',
            name: 'DISCLOSURE',
            meta: {
                title: '复星国际证券开户',
                des: '风险披露',
            },
            component: () => import(/* webpackChunkName: "openAccountMain" */ '@/views/openAccount/step/Disclosure'),
        },
        {
            path: '/sign',
            name: 'SIGNATURE',
            meta: {
                title: '复星国际证券开户',
                des: '签署协议',
            },
            component: () => import(/* webpackChunkName: "openAccountMain" */ '@/views/openAccount/step/Signature'),
        },
        {
            path: '/signature',
            name: 'signaturePad',
            meta: {
                title: '复星国际证券开户',
                des: '签名',
                // 对应步骤
                stepName: 'SIGNATURE',
            },
            component: () => {
                // 检测并保存合规标识
                const { isCompliance } = detectAndSaveComplianceFlags()

                if (isCompliance) {
                    return import(/* webpackChunkName: "complianceAccountViews" */ '@/views/complianceAccount/Signature.vue')
                }
                // 如果不是合规模式，跳转到签署协议页面
                return import(/* webpackChunkName: "openAccountMain" */ '@/views/openAccount/step/SignaturePad')
            },
        },
        {
            path: '/livingWitness',
            name: 'FACEID',
            meta: {
                title: '复星国际证券开户',
                des: '活体识别',
            },
            component: () => import(/* webpackChunkName: "openAccountMain" */ '@/views/openAccount/step/FaceId'),
        },
        {
            path: '/caApply',
            name: 'APPLYCA',
            meta: {
                title: '复星国际证券开户',
                des: '证书申请',
            },
            component: () => import(/* webpackChunkName: "openAccountMain" */ '@/views/openAccount/step/ApplyCA'),
        },
        {
            path: '/openStatus',
            name: 'openStatus',
            meta: {
                title: '复星国际证券开户',
                des: '开户状态',
                submited: true,
            },
            component: () => import(/* webpackChunkName: "openAccountMain" */ '@/views/openAccount/pages/OpenStatus.vue'),
        },
        {
            path: '/status',
            name: 'COMPLIANCE_STATUS',
            meta: {
                title: '合规出入金审核状态',
                des: '合规出入金审核状态',
                submited: true,
            },
            component: () => {
                // 检测并保存合规标识
                const { isCompliance } = detectAndSaveComplianceFlags()

                if (isCompliance) {
                    return import(/* webpackChunkName: "complianceAccountViews" */ '@/views/complianceAccount/Status.vue')
                }
                // 如果不是合规模式，跳转到普通开户状态页面
                return import(/* webpackChunkName: "openAccountMain" */ '@/views/openAccount/pages/OpenStatus.vue')
            },
        },
        {
            path: '/C_SearchCompany',
            name: 'C_SearchCompany',
            meta: {
                title: '公司搜索',
                des: '公司搜索',
            },
            component: () => import(/* webpackChunkName: "openAccountMain" */ '@/views/openAccount/pages/SearchCompany.vue'),
        },
        {
            path: '/mrStatus',
            name: 'MRStatus',
            component: () => import(/* webpackChunkName: "openAccountMain" */ '@/views/mr/mrStatus.vue'),
        },
        {
            path: '/accountPrompt',
            name: 'AccountPrompt',
            meta: {
                title: '复星国际证券开户',
            },
            component: () => import(/* webpackChunkName: "openAccountMain" */ '@/views/openAccount/pages/accountPrompt.vue'),
        },
        ...HKPage,
    ],
})

router.beforeResolve((to, from, next) => {
    // ======= 所有项目必须同步内容 START =======
    const wtToken = to.query.wtToken || ''
    const sub = to.query.sub || ''
    if (wtToken) {
        store.dispatch('user/setWTToken', wtToken)
    }
    if (sub) {
        store.dispatch('user/setSubAccountId', sub)
    }

    // ======= 所有项目必须同步内容 END =======

    // 检测并保存合规标识
    const { isCompliance } = detectAndSaveComplianceFlags()

    const applyInfo = openAccountStore.getters['account/getUserInfo'] || {}
    // 如果开户已提交（>= 2000），且非提交后页面，就将页面跳转回去
    // 但是合规开户模式下跳过这个检查
    if (!isCompliance && (applyInfo?.applyStatus >= approvingStatusCode || applyInfo?.applyStatus === preOpenStatusCode) && !to.meta?.submited) {
        console.log('status not allow: ', applyInfo.applyStatus)
        next({
            name: from.name,
            replace: true,
        })
    } else {
        // 路由变更时更新currentStep
        const steps = openAccountStore.state?.account?.applyStepsName ?? []

        const toStepName = to.meta?.stepName || to.name

        if (steps.includes(toStepName)) {
            openAccountStore.dispatch('account/updateCurrentStep', toStepName)
        }

        next()
    }
})

router.beforeEach(async (to, from, next) => {
    !JSBridge && NProgress.start()
    // 存在 title 则设置 title（在合规模式下合并合规多语言）
    // 检测并保存合规标识
    const { isCompliance } = detectAndSaveComplianceFlags()
    if (isCompliance) {
        // 将合规词条合并到 openAccount i18n，避免合规页面在 openAccount 内取词失败
        const lang = i18n.locale || 'zhCn'
        const complianceMessages = complianceI18n?.messages?.[lang] || {}
        i18n.setLocaleMessage(lang, {
            ...i18n.getLocaleMessage(lang),
            ...complianceMessages,
        })
    }

    const matchTitle = i18n.t(to.meta.title || 'pageTitle')
    document.title = matchTitle
    if (isTHSI18NApp()) {
        document.title = FISL_ACCOUNT_OPEN_TITLE
        thsI18NJsBridge?.changeWebViewTitle?.(FISL_ACCOUNT_OPEN_TITLE)
    }

    if (to.query.fhsid) {
        store.commit('user/updateSession', { session: to.query.fhsid })
    }

    if (!store.state.user.session) {
        await store.dispatch('user/login')
    }
    window.scrollTo(0, 0)
    // // TODO: 主题设置
    // if (['/openStatus', '/AccountStatus'].includes(to.path) && getRunEnv() === 1) {
    //     setTheme()
    // } else if (getRunEnv() === 1) {
    //     removeTheme()
    // }
    next()
    /** myLink中增加关闭窗口的功能 */
    setTimeout(() => {
        if (MYLINK_JSBRIDGE.isInMylink()) {
            MYLINK_JSBRIDGE.setNavigationButtons({
                backVisible: true,
                right1icon: 'btn_ol_close',
                right1link: 'closeAll', // 参看 mylink jsBridge文档
            })
        }
    }, 200)
})

router.afterEach(() => {
    store.commit('user/updateShowLoading', false)
    !JSBridge && NProgress.done()
})

const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
    return originalPush.call(this, location).catch(err => {
        console.warn(err)
    })
}
const originalReplace = VueRouter.prototype.replace
VueRouter.prototype.replace = function push(location) {
    return originalReplace.call(this, location).catch(err => {
        console.warn(err)
    })
}

// function getTitle() {
//     if (isTHSI18NApp()) {
//         return FISL_ACCOUNT_OPEN_TITLE
//     }
//     return '复星国际证券开户'
// }

export default router
